import React, { useEffect, useState } from 'react'
import Header from '../components/header'
import Edit from './Edit'
import { Grid, Box, Button } from '@chakra-ui/core'
import { useGlobalState, getGlobalState, setGlobalState } from '../store'
import { setRemoteCall } from '../remote'
import Map from '../components/Map/Map'
import TableProvider from '../components/Table/Table'

/**
 * Table collumns
 */
export const tableCollumns = [
  { k: '_id', l: '_id' },
  { k: 'name', l: 'Nome' },
  { k: 'code', l: 'Código' },
  { k: 'type', l: 'Tipo' },
  // { k: 'priority', l: 'Prioridade', t: 'number' },
  // { k: 'details', l: 'Detalhes', t: 'textarea' },
  // { k: 'status', l: 'Estado' },
  { k: 'location', l: 'Localização', t: 'map' },
  { k: 'startDate', l: 'Data de Inicio', t: 'datetime' },
  { k: 'endDate', l: 'Data Final', t: 'datetime' }
  // { k: 'attr', l: 'Atributos' },
]
export const typesCollumns = [
  { k: '_id', l: '_id' },
  { k: 'name', l: 'Nome' },
  { k: 'details', l: 'Detalhes', t: 'textarea' },
  { k: 'color', l: 'Cor', t: 'color' },
  { k: 'status', l: 'Estado' }
  // { k: 'attr', l: 'Atributos' },
]

export default function Projects(props) {
  /**
   * Get Data
   */
  const [openModal, setOpenModal] = useState(false)
  const [view, setView] = useState('projects')
  const [data, setData] = useGlobalState('projects')
  const [types, setTypes] = useGlobalState('projectTypes')
  //set the initical class name
  setGlobalState('pageClass', 'projects')

  const collumns = view === 'projects' ? tableCollumns : typesCollumns

  /**
   * Table data
   */
  const projects = view === 'projects' ? data : types

  /**
   * Table options
   */
  const options = {
    filter: true,
    filterType: 'dropdown',
    tableBodyHeight: 'calc( 100vh - 260px )',
    count: projects ? projects.length : 0,
    downloadOptions: { filename: 'report.csv', separator: ';' },

    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      const selectedIds = selectedRows.data.map(
        sel => projects[sel.dataIndex] && projects[sel.dataIndex]._id
      )

      const actionType = view === 'projects' ? 'delProjects' : 'delProjectTypes'
      const actionMessage =
        view === 'projects' ? ` Deleted projects` : ` Deleted projects types`

      return (
        <div className="table-actions">
          {/* <Button
            variantColor="red"
            onClick={() =>
              setRemoteCall(actionType, selectedIds, actionMessage)
            }
          >
            Delete Selected
          </Button> */}
        </div>
      )
    },
    onRowClick: (rowData, rowMeta) => {
      setOpenModal(projects[rowMeta.dataIndex])
    }
  }

  /**
   * Set table data
   */
  const set = (data, notice) => {
    console.log(data)
    setRemoteCall(
      view === 'projects' ? 'setProjects' : 'setProjectTypes',
      data,
      notice
    )
  }
  return (
    <div className={'table-wrapper'}>
      <Box w="40%" className={'content'}>
        <Header>
          {/* <button onClick={() => props.socket.emit('page', 'games')}>
          Isto é o que está a acontecer hoje
        </button> */}
          <Grid templateColumns="repeat(2, 1fr)" gap={6} padding={'0 1em'}>
            <Box w="100%">
              <h1>Projetos</h1>
            </Box>

            <Box w="100%" h="10">
              {view === 'projects' && (
                <Button
                  active={props.periodType === 'week'}
                  width={'50%'}
                  onClick={() => setView('types')}
                >
                  <span className={`text`}>
                    <span className={`icon-book-open icons`} /> Tipos
                  </span>
                </Button>
              )}
              {view === 'types' && (
                <Button
                  active={props.periodType === 'week'}
                  width={'50%'}
                  onClick={() => setView('projects')}
                >
                  <span className={`text`}>
                    <span className={`icon-location-pin icons`} /> Projetos
                  </span>
                </Button>
              )}
              <Button
                active={props.periodType === 'week'}
                width={'49%'}
                marginLeft={'1%'}
                variantColor="green"
                onClick={() => setOpenModal({})}
              >
                <span className={`text`}>
                  <span className={`icon-plus icons`} />
                </span>
              </Button>
            </Box>
          </Grid>
        </Header>

        {projects && (
          <div className={'contentTableMap'}>
            <div className={'tableWrapper'}>
              <TableProvider
                data={projects}
                columns={collumns.map(key => {
                  if (key.k === 'status') {
                    return {
                      name: key.k,
                      label: key.l,
                      selector: key.k,
                      options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value, tableMeta, updateValue) => {
                          return Number(value) === 1 ? 'Ativo' : 'Desativo'
                        }
                      }
                    }
                  }
                  if (key.k === 'type') {
                    return {
                      name: key.k,
                      label: key.l,
                      selector: key.k,
                      options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value, tableMeta, updateValue) => {
                          if (types && types.length > 0 && value) {
                            const thisType = types.find(t =>
                              value.includes(t._id)
                            )
                            return thisType && thisType.name
                          }
                          return ''
                        }
                      }
                    }
                  }
                  if (key.k === 'status') {
                    return {
                      name: key.k,
                      label: key.l,
                      selector: key.k,
                      options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value, tableMeta, updateValue) => {
                          return value === 1 ? 'Ativo' : 'Desativo'
                        }
                      }
                    }
                  }
                  return {
                    name: key.k,
                    label: key.l,
                    selector: key.k,
                    options: {
                      filter: true,
                      sort: true,
                      display:
                        key.k !== '_id' &&
                        key.k !== '__v' &&
                        key.k !== 'location'
                    }
                  }
                })}
                options={options}
              />
            </div>
          </div>
        )}
        {openModal && (
          <Edit
            data={openModal}
            form={collumns}
            set={set}
            types={types}
            setOpenModal={setOpenModal}
          />
        )}
      </Box>
      <Box w="60%" className={'map'}>
        <Map
          center={projects.map(prj => {
            const thisType = types.find(
              types => prj.type && prj.type.includes(types._id)
            )
            return {
              id: prj._id,
              center: prj.location,
              name: prj.name,
              description: prj.description,
              color: thisType ? thisType.color : undefined,
              details: prj
            }
          })}
          onClick={marker => {
            setOpenModal(marker.details)
          }}
        ></Map>
      </Box>
    </div>
  )
}
